import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 md:px-8 bg-nightBlue border-t border-white/5" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row items-center gap-6 bg-teal/10 border border-teal/20 rounded-2xl p-8" data-id="element-55">
          <div className="flex-shrink-0" data-id="element-56">
            <ShieldCheckIcon className="w-16 h-16 text-teal" data-id="element-57" />
          </div>
          <div className="text-center md:text-left" data-id="element-58">
            <h3 className="font-montserrat font-bold text-xl text-warmWhite mb-2" data-id="element-59">
              Garantía de 7 Noches
            </h3>
            <p className="font-lato text-base md:text-lg text-warmWhite/80" data-id="element-60">
              Si en 7 noches no notas ningún cambio, te devuelvo cada centavo.
              Sin preguntas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}